/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
*/

import { InternationalizationAPI } from "../../context/translation.js";
import { FormLanguagePolicy } from "../forms-types.js";

export function vqfLanguagePolicy(
  i18n: InternationalizationAPI,
): FormLanguagePolicy {
  return {
    officialLanguages: ["de", "en"],
    legallyBindingLanguages: ["de"],
    fallbackLanguage: "en",
    legallyBindingLanguageLabel: i18n.fixed({ en: "German", de: "Deutsch" }),
    fallbackLanguageLabel: i18n.fixed({ en: "English", de: "Englisch" }),
  };
}
